import { makeVar } from "@apollo/client";
import type { ToastButtonTextType, ToastTextType } from "~/const/toast-text";
import { TOAST_BUTTON_TEXT, TOAST_TEXT } from "~/const/toast-text";

type OpenAttachedButtonToastArgs = {
  toastText: ToastTextType;
  toastButtonText: ToastButtonTextType;
  onButtonClicked: () => void;
};

type InitialState = {
  isVisible: boolean;
  labelText: string;
  buttonLabelText: string;
  onButtonClicked?: () => void;
};

const initialState: InitialState = {
  isVisible: false,
  labelText: "",
  buttonLabelText: "",
  onButtonClicked: undefined,
};

export const toastState = makeVar(initialState);

export const openTextOnlyToast = (toastText: ToastTextType) => {
  toastState({
    isVisible: true,
    labelText: TOAST_TEXT[toastText],
    buttonLabelText: "",
    onButtonClicked: undefined,
  });
};

export const openAttachedButtonToast = ({
  toastText,
  toastButtonText,
  onButtonClicked,
}: OpenAttachedButtonToastArgs) => {
  toastState({
    isVisible: true,
    labelText: TOAST_TEXT[toastText],
    buttonLabelText: TOAST_BUTTON_TEXT[toastButtonText],
    onButtonClicked,
  });
};

export const closeToast = () => {
  toastState({ ...toastState(), isVisible: false });
};
